import { PREMIUM_PAGE_ROUTES } from "../../../Containers/NewPremiumPage/Utils/constants";
import { getDigitalDukaanWebviewLink } from "../../../Containers/NewPremiumPage/Utils/getRoutingLink";
import {
  getDomainName,
  renewDomainSubscription,
} from "../../../Containers/NewPremiumPage/Utils/getSubscriptionDetails";
import moment from "moment";

export const getHeading = (isRenewCard, isExpired) => {
  const expiredStateText = "Your domain has expired!";
  const aboutToExpireStateText = "Your domain is about to expire!";
  const defaultText = "Best Suited Domain";

  return isRenewCard ? isExpired ? expiredStateText : aboutToExpireStateText : defaultText;
};

export const getPriceData = (domainRenewalDetail, domainSearchData, isRenewCard) => {
  const renewalPriceData = {
    mrp: domainRenewalDetail?.renewal_price,
    discount: domainRenewalDetail?.discount,
  };

  const purchasePriceData = {
    mrp: domainSearchData?.primary_result?.purchase_price,
    discount: domainSearchData?.primary_result?.discount,
  };

  const finalPriceData = isRenewCard ? renewalPriceData : purchasePriceData;

  return {
    ...finalPriceData,
    effectivePrice: finalPriceData.mrp - finalPriceData.discount,
  };
};

export const getRenewalYears = (domainRenewalDetail) => {
  return moment(domainRenewalDetail?.renewal_end_date).year() - moment(domainRenewalDetail?.renewal_start_date).year();
};

export const getCtaTextAndHandler = (data, handleDomainCart, isRenewCard) => {
  const renewalCtaTextAndHandler = {
    ctaText: "Renew Now",
    handler: renewDomainSubscription,
  };
  const purchaseCtaTextAndHandler = {
    ctaText: "Get It Now",
    handler: () => handleDomainCart(data?.primary_result),
  };

  return isRenewCard ? renewalCtaTextAndHandler : purchaseCtaTextAndHandler;
};

export const getColorConfig = (isRenewCard, isExpired) => {
  const expiredColorConfig = {
    ctaColor: "#9A0C00",
    domainInfoBackground: "#FBE7E6",
  };
  const aboutToExpireColorConfig = {
    ctaColor: "#B57900",
    domainInfoBackground: "#FCF3DE",
  };
  const defaultColorConfig = {
    ctaColor: "#5B488D",
    domainInfoBackground: "#F1EDFF",
  };

  return isRenewCard ? isExpired ? expiredColorConfig : aboutToExpireColorConfig : defaultColorConfig;
};

export const getDomainNameToDisplay = (data, isRenewCard) => {
  return isRenewCard ? getDomainName() : data?.primary_result?.domain_name;
};
